import React, { createContext, Dispatch } from "react"
import { EntregadoresInicial, type EntregadoresModel } from "../models/entregadoresModel"
import type { EntregadoresActions } from "./entregadoresActions"

interface EntregadoresContextValue {
    dados: EntregadoresModel
    dispatch: Dispatch<EntregadoresActions>
    erroCarregamento: string | null
}

export const EntregadoresContext = createContext<EntregadoresContextValue>({
    dados: EntregadoresInicial,
    dispatch: () => undefined,
    erroCarregamento: null,
})
